import FirebaseContext, { consumerFirebase } from './context'
import Firebase from './firebaseConfig'

export default Firebase;
export { FirebaseContext, consumerFirebase };